// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4332":"ec37484e","5002":"93a86323"}[chunkId] + ".chunk.css";
};